import { useEffect, useState } from 'react'
import { Doughnut } from 'react-chartjs-2'
import WTypography from 'Components/whiteTypography'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import { STATUS_COLORS, STATUS_SERIES } from '../statusPalette' // LAP — palette unifiée

function Chart1({ tasks, handleMesTaches }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [chartDTasks, setChartDTasks] = useState({})
  const [revData, setRevData] = useState({
    labels: ['Non démarré', 'En cours', 'En retard', 'Terminées'],
    datasets: [
      {
        data: [80, 5, 15, 10],
        backgroundColor: STATUS_SERIES,
        borderColor: STATUS_SERIES,
        borderWidth: 0,
        borderRadius: 6, // LAP — segments arrondis, rendu plus doux
        spacing: 2,
        hoverOffset: 4,
        precision: 0,
      },
    ],
  })

  const optiondonut = {
    responsive: true,
    aspectRatio: 1,
    maintainAspectRatio: false,

    onClick: function (evt, element) {
      if (element.length > 0) {
        let catName = revData.labels[element[0].index]
        // console.log(catName)
        if (catName === 'Terminées') {
          catName = 'Fait'
        }
        if (catName === 'En cours') {
          catName = 'En-Cours'
        }
        if (catName === 'Terminées') {
          catName = 'Fait'
        }
        if (catName === 'En retard') {
          catName = 'En-retard'
        }
        handleMesTaches('', catName)
      }
    },
    clip: true,
    cutout: '80%',
    plugins: {
      datalabels: {
        display: false,
      },

      legend: {
        display: false,
        events: [],
      },
    },
  }
  useEffect(() => {
    let remaingt = 0
    let non = 0
    let encours = 0
    let enretard = 0
    let terminees = 0
    tasks.forEach((v) => {
      if (v.Statut !== 'Fait') {
        remaingt++
      }
      if (v.Statut === 'Fait') {
        terminees++
      }
      if (v.Statut === 'En-Cours') {
        encours++
      }
      if (v.Statut === 'En-retard') {
        enretard++
      }
      if (v.Statut === 'Non démarré') {
        non++
      }
    })
    setChartDTasks({
      remaingt,
      non,
      encours,
      enretard,
      terminees,
    })
    setRevData({
      labels: ['Non démarré', 'En cours', 'En retard', 'Terminées'],
      datasets: [
        {
          data: [non, encours, enretard, terminees],
          backgroundColor: STATUS_SERIES,
          borderColor: STATUS_SERIES,
          borderWidth: 0,
          borderRadius: 6, // LAP — segments arrondis, rendu plus doux
          spacing: 2,
          hoverOffset: 4,
          precision: 0,
        },
      ],
    })
  }, [tasks])

  const RevDoughnutChart = () => (
    <Box sx={{ margin: '10px', position: 'relative', width: '100%', maxWidth: '350px' }}>
      <Box height={210} position={'relative'} width={'100%'}>
        <Doughnut data={revData} options={optiondonut} />
      </Box>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          bottom: '50%',
          left: '50%',
          right: '50%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          ':hover': {
            cursor: 'pointer',
          },
        }}
      >
        <WTypography sx={{ color: 'white', whiteSpace: 'nowrap' }} variant="h3" align="center">
          {chartDTasks.remaingt}
        </WTypography>
        <WTypography sx={{ color: 'white', whiteSpace: 'nowrap' }} variant="h7" align="center">
          {t('mesToDo.remainingTasks')}
        </WTypography>
      </Box>
    </Box>
  )

  return (
    <Box display={'flex'} justifyContent={'center'} flexDirection={'column'} alignItems={'center'}>
      <RevDoughnutChart sx={{ margin: '10px' }} />
      {/* LAP — légende pilotée par les données : lignes pleine largeur,
          pastille de couleur + libellé + compteur, cliquables pour filtrer */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'stretch',
          flexDirection: 'column',
          marginTop: '6px',
          width: '100%',
          maxWidth: '280px',
          gap: '2px',
        }}
      >
        {[
          {
            label: t('mesToDo.statusNotStartedAlt'),
            count: chartDTasks.non,
            color: STATUS_COLORS.notStarted,
            filter: 'Non démarré',
          },
          {
            label: t('mesToDo.statusInProgressAlt'),
            count: chartDTasks.encours,
            color: STATUS_COLORS.inProgress,
            filter: 'En-Cours',
          },
          {
            label: t('mesToDo.statusLateAlt'),
            count: chartDTasks.enretard,
            color: STATUS_COLORS.late,
            filter: 'En-retard',
          },
          {
            label: t('mesToDo.statusCompletedAlt'),
            count: chartDTasks.terminees,
            color: STATUS_COLORS.done,
            filter: 'Fait',
          },
        ].map((row) => (
          <Box
            key={row.filter}
            sx={{
              display: 'flex',
              alignItems: 'center',
              padding: '4px 10px',
              borderRadius: '8px',
              cursor: 'pointer',
              ':hover': { background: 'rgba(255,255,255,0.08)' },
            }}
            onClick={() => handleMesTaches('', row.filter)}
          >
            <Box
              sx={{
                width: '10px',
                height: '10px',
                borderRadius: '3px',
                background: row.color,
                marginRight: '10px',
                flexShrink: 0,
              }}
            />
            <WTypography variant="h7">{row.label}</WTypography>
            <WTypography sx={{ marginLeft: 'auto', color: 'white', fontWeight: 600 }} variant="h7">
              {row.count}
            </WTypography>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default Chart1
